import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router";
import api from "../../api/api";
import { useAuth } from "../../features/auth/AuthContext";
import { getAllCoursesByTeacherId } from "../../state/actions/getAllCoursesByTeacherIdAction";
import alert_img from "../../assets/images/alert-image.svg";
import nodata from "../../assets/images/nodata.svg";
import SearchComponent from "../SearchComponent/SearchComponent";
import { copy_lesson_image, search } from "../../assets/images/images";
import { Pagination } from "@mui/material";
import { toast } from "react-toastify";
import copyLessons_loader_gif from "../../assets/images/copyLessons_LoaderGif.gif";

export default function CopyLessonsModal({
  course,
  open,
  onClose,
  onSubmit,
  mode = "copy",
  courseId,
  teacherId,
  setIsCopyingLessons,
}) {
  const dispatch = useDispatch();

  const [step, setStep] = useState(
    mode === "copy" ? "course" : "lesson",
  );
  const [selectedCourse, setSelectedCourse] = useState(
    courseId || null,
  );
  const [duplicateCount, setDuplicateCount] = useState(1);
  const [lessons, setLessons] = useState([]);
  const [selectedLessons, setSelectedLessons] = useState({});
  const [selectedAssignments, setSelectedAssignments] =
    useState({});
  const [loadingLessons, setLoadingLessons] = useState(false);
  const [expandedLessonId, setExpandedLessonId] =
    useState(null);
  const [assignmentsMap, setAssignmentsMap] = useState({});
  const [loadingAssignments, setLoadingAssignments] =
    useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [searchOption, setSearchOption] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lessonPage, setLessonPage] = useState(1);
  const [lessonTotalPages, setLessonTotalPages] = useState(1);
 const [totalLessonCount, setTotalLessonCount] = useState(0);

  const coursesState = useSelector(
    (state) => state.getallCoursesByTeacherId,
  );

  const courses = coursesState?.courses || [];

  const filteredCourses = (courses || []).filter((course) => {
    const hasValidRole =
      course.my_role === "owner" ||
      course.my_role === "editor" ||
      course.my_role === null;

    const matchesSearch = searchOption?.trim()
      ? course?.name
          ?.toLowerCase()
          ?.includes(searchOption.toLowerCase())
      : true;

    return hasValidRole && matchesSearch;
  });

  const totalCount = coursesState?.count || 0;

  const { token } = useAuth();
  const navigate =useNavigate();
  const activeCourseId =
  mode === "copy"
    ? selectedCourse
    : courseId || course?.course_id;

  const selectedCourseData =
    mode === "duplicate"
      ? course
      : courses?.find(
          (c) => c.course_id === activeCourseId,
        );

  // RESET
  useEffect(() => {
    if (!open) {
      setStep(mode === "copy" ? "course" : "lesson");
      setSelectedCourse(null);
      setDuplicateCount(1);
      setLessons([]);
      setSelectedLessons({});
      setSelectedAssignments({});
      setExpandedLessonId(null);
      setAssignmentsMap({});
      setLoadingAssignments({});
    }
  }, [open, mode]);

  // FETCH COURSES
  useEffect(() => {
    if (!open || mode !== "copy") return;

    dispatch(
      getAllCoursesByTeacherId(
        page,
        teacherId,
        token,
        searchOption,
        true,
        "",
      ),
    );
  }, [
    open,
    mode,
    page,
    teacherId,
    token,
    searchOption,
    dispatch,
  ]);

  // TOTAL PAGES
  useEffect(() => {
    setTotalPages(Math.ceil(totalCount / 12) || 1);
  }, [totalCount]);

  useEffect(() => {
    if (
      open &&
      mode === "copy" &&
      !selectedCourse &&
      courses?.length > 0
    ) {
      setSelectedCourse(courses[0]?.course_id);
    }
  }, [open, mode, courses, selectedCourse]);

  // FETCH LESSONS
  useEffect(() => {
    if (!activeCourseId || step !== "lesson") return;

    const fetchLessons = async () => {
      setLoadingLessons(true);

      try {
        const res = await api.get(
          `lessons/get-all-lessons/course/${activeCourseId}/`,
          {
              params: {
                page: lessonPage,
            },
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
          },
        );

        setLessons(res.data?.data || []);
        setTotalLessonCount(res.data?.count || 0);
        setLessonTotalPages(Math.ceil((res.data?.count || 0) / 12) || 1);
      } catch (err) {
        console.error("Lessons API failed", err);

        setLessons([]);
      } finally {
        setLoadingLessons(false);
      }
    };

    fetchLessons();
  }, [activeCourseId, step, token,lessonPage]);

const lessonCount = Object.keys(selectedLessons).length;
const assignmentCount = Object.keys(selectedAssignments).length;

const getDuplicateMessage = () => {
  if (lessonCount > 0 && assignmentCount > 0) {
    return `Are you sure you want to duplicate ${course?.name} with selected Lesson${
      lessonCount > 1 ? "s" : ""
    } & Assignment${
      assignmentCount > 1 ? "s" : ""
    }?`;
  }

  if (lessonCount > 0) {
    return `Are you sure you want to duplicate ${course?.name} with selected Lesson${
      lessonCount > 1 ? "s" : ""
    }?`;
  }

  if (assignmentCount > 0) {
    return `Are you sure you want to duplicate ${course?.name} with selected Assignment${
      assignmentCount > 1 ? "s" : ""
    }?`;
  }

  return `Are you sure you want to duplicate ${course?.name} without any selected Lessons or Assignments?`;
};
  const fetchAssignments = async (id) => {
    try {
      const res = await api.get(
        `assignments/get-assignments-by-lesson/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        },
      );

      return res.data || [];
    } catch (err) {
      if (err.response?.status === 404) {
        return [];
      }

      return [];
    }
  };

  const handleSearch = (e) => {
    setSearchOption(e.target.value);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };
 const handleLessonPageChange = (event, value) => {
  setLessonPage(value);
};

const handleModal = () => {

  if (step === "course" && mode === "copy" && !selectedCourse) {
    toast.error("Please select a course to copy lessons from.");
    return;
  }
    if (step === "lesson" && mode === "copy" && Object.keys(selectedLessons).length === 0) {
    toast.error("Please select at least one lesson to copy.");
    return;
  }
     setOpenDialog(true)
};

 const allSelected =
  Object.keys(selectedLessons).length === totalLessonCount;
  
  const headerTitle =
    step === "course" && mode === "copy"
      ? "Select your Course"
      : step === "lesson" && mode === "copy"
      ? `Select your Lessons to Copy from ${selectedCourseData?.name} to ${course?.name}`
      : step === "lesson" && mode === "duplicate"
      ? "Duplicate Course"
      : "";

  // SUBMIT
  const handleSubmit = async () => {
    const lesson_ids = Object.keys(selectedLessons).map(
      Number,
    );

    const assignment_ids = Object.keys(
      selectedAssignments,
    ).map(Number);

    let payload = {
      lesson_ids,
      assignment_ids,
    };

    if (mode === "copy") {
      payload = {
        ...payload,
        target_course_ids: [selectedCourse],
        copy_lesson_file: true,
      };
    }

    if (mode === "duplicate") {
      payload = {
        ...payload,
        course_id: courseId,
        count: duplicateCount,
      };
    }

 try {
   setOpenDialog(false);
   onClose();

   setIsCopyingLessons?.(true);
if (mode === "duplicate") {
  navigate("/dashboard/home", {
    state: { showDuplicateLoader: true },
  });
}
   await onSubmit(payload);
 } catch (err) {
   console.error(err);

   setIsCopyingLessons?.(false);

   toast.error("Failed to copy lessons");
 }
  };

const toggleSelectAll = async () => {
  if (allSelected) {
    setSelectedLessons({});
    setSelectedAssignments({});
    return;
  }

  // Fetch all lessons for the course if not already done
  const allLessons = await fetchAllLessons();

  // Immediately select all lessons for instant UI feedback
  const newLessons = {};

  allLessons.forEach((lesson) => {
    newLessons[lesson.lesson_id] = true;
  });

  setSelectedLessons(newLessons);

  // Background Fetch assignments for all lessons and update state once done
  (async () => {
    const updatedAssignmentsMap = { ...assignmentsMap };
    const newAssignments = {};

    await Promise.all(
      allLessons.map(async (lesson) => {
        const lessonId = lesson.lesson_id;

        if (!updatedAssignmentsMap[lessonId]) {
          try {
            const data = await fetchAssignments(lessonId);

            updatedAssignmentsMap[lessonId] =
              data?.data || [];
          } catch {
            updatedAssignmentsMap[lessonId] = [];
          }
        }

        updatedAssignmentsMap[lessonId].forEach(
          (assignment) => {
            newAssignments[assignment.assignment_id] = true;
          }
        );
      })
    );

    setAssignmentsMap(updatedAssignmentsMap);
    setSelectedAssignments(newAssignments);
  })();
};
  const toggleLesson = async (lesson) => {
  const lessonId = lesson.lesson_id;

  const isSelected = !!selectedLessons[lessonId];

  // Instant UI update
  setSelectedLessons((prev) => {
    const updated = { ...prev };

    if (isSelected) {
      delete updated[lessonId];
    } else {
      updated[lessonId] = true;
    }

    return updated;
  });

  let lessonAssignments = assignmentsMap[lessonId];

  if (!lessonAssignments) {
    const data = await fetchAssignments(lessonId);

    lessonAssignments = data?.data || [];

    setAssignmentsMap((prev) => ({
      ...prev,
      [lessonId]: lessonAssignments,
    }));
  }

  setSelectedAssignments((prev) => {
    const updated = { ...prev };

    if (isSelected) {
      lessonAssignments.forEach((a) => {
        delete updated[a.assignment_id];
      });
    } else {
      lessonAssignments.forEach((a) => {
        updated[a.assignment_id] = true;
      });
    }

    return updated;
  });
};
  const fetchAllLessons = async () => {
  let page = 1;
  let allLessons = [];
  let totalPages = 1;

  do {
    const res = await api.get(
      `lessons/get-all-lessons/course/${activeCourseId}/`,
      {
        params: { page },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    allLessons.push(...(res.data?.data || []));

    totalPages = Math.ceil((res.data?.count || 0) / 12);
    page++;
  } while (page <= totalPages);

  return allLessons;
};

  const toggleAssignment = (lesson, assignment) => {
  const lessonId = lesson.lesson_id;

  const newAssignments = {
    ...selectedAssignments,
  };

  const newLessons = {
    ...selectedLessons,
  };

  if (newAssignments[assignment.assignment_id]) {
    delete newAssignments[assignment.assignment_id];
  } else {
    newAssignments[assignment.assignment_id] = true;
    newLessons[lessonId] = true;
  }

  setSelectedAssignments(newAssignments);
  setSelectedLessons(newLessons);
};
  const handleToggleLessonExpand = async (lessonId) => {
    if (expandedLessonId === lessonId) {
      setExpandedLessonId(null);

      return;
    }

    setExpandedLessonId(lessonId);

    if (assignmentsMap[lessonId]) return;

    setLoadingAssignments((prev) => ({
      ...prev,
      [lessonId]: true,
    }));

    try {
      const data = await fetchAssignments(lessonId);

      const normalized = data?.data || [];

      setAssignmentsMap((prev) => ({
        ...prev,
        [lessonId]: normalized,
      }));
    } catch (err) {
      console.error(
        "Failed to fetch assignments",
        err,
      );
    } finally {
      setLoadingAssignments((prev) => ({
        ...prev,
        [lessonId]: false,
      }));
    }
  };
useEffect(() => {
  setLessonPage(1);
}, [activeCourseId]);
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-[2px] flex items-center justify-center z-50 px-3 sm:px-4"
    >
      {/* MAIN MODAL */}
      <div
        className={`bg-white rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.2)] flex flex-col overflow-hidden w-full ${
          step === "count" && mode === "duplicate"
            ? "max-w-[650px]"
            : "max-w-[960px]"
        } max-h-[90vh]`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3 px-4 sm:px-6 py-4 border-b relative ">
          <h2 className="text-[16px] sm:text-[18px] font-semibold text-gray-800 leading-6 break-words">
            {headerTitle}
          </h2>

          <div className="flex items-center gap-1">
            {mode === "copy" &&
             step === "course" && (
              <div className="sm:w-[240px] md:w-[620px]">
                <SearchComponent
                  search={search}
                  searchPlaceholder="Search Course"
                  searchValue="search"
                  onchange={handleSearch}
                  name="searchOption"
                  value={searchOption}
                />
              </div>
            )}

            <button
              onClick={onClose}
              className=" absolute top-4 right-4 bg-transparent border-none text-3xl sm:text-4xl leading-none"
            >
              ×
            </button>
          </div>
        </div>

        {/* BODY */}
        <div className="flex-1 overflow-y-auto px-4 sm:px-6 py-3">
          {/* COURSE STEP */}
          {step === "course" &&
            mode === "copy" &&
            (filteredCourses?.length > 0 ? (
              <>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {filteredCourses.map((course) => {
                    const isSelected = selectedCourse === course.course_id;

                    return (
                      <div
                        key={course.course_id}
                        onClick={() => setSelectedCourse(course.course_id)}
                        className={`cursor-pointer shadow-md hover:shadow-lg rounded-xl p-3 h-full w-full border transition-all ${
                          isSelected ? "border-black" : "border-transparent"
                        }`}
                      >
                        <img
                          src={course.image}
                          alt="Course"
                          className="h-[180px] sm:h-[140px] w-full object-cover rounded-lg mb-2"
                        />

                        <div className="studentDashboar-Suggested-Courses-profile-folder">
                          <div className="studentDashboar-Suggested-Courses-profile">
                            <div className="studentDashboar-profile-image">
                              <img
                                src={
                                  course?.ai_avatar ?? course.teacher_profile
                                }
                                alt=""
                              />
                            </div>

                            <div className="studentDashboar-Suggested-Courses-profile-title">
                              <h2 className="tudentDashboar-profile-card-title break-words">
                                {course?.teacher_name}

                                <p
                                  style={{
                                    color: "grey",
                                  }}
                                >
                                  Teacher
                                </p>
                              </h2>
                            </div>
                          </div>
                        </div>

                        <p className="text-xs opacity-70 break-words">
                          {course.subject}
                        </p>

                        <p className="text-sm font-semibold break-words">
                          {course.name}
                        </p>
                      </div>
                    );
                  })}
                </div>

               { totalPages > 1 && (
                <div className="flex justify-center mt-5">
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    color="primary"
                  />
                </div>)}
              </>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "60px 16px",
                  color: "#94a3b8",
                }}
              >
                <img
                  src={nodata}
                  alt="no courses"
                  style={{
                    width: "90px",
                    margin: "0 auto 12px",
                  }}
                />

                {searchOption?.trim() ? (
                  <>
                    <p className="text-sm font-bold">No Course Found</p>

                    <p className="text-xs mt-1">
                      No courses matched your search.
                    </p>
                  </>
                ) : (
                  <>
                    <p className="text-sm font-bold">
                      Looks Like you haven't created any courses yet
                    </p>

                    <p className="text-xs mt-1">
                      Once you have created a course, your courses will show up
                      here
                    </p>
                  </>
                )}
              </div>
            ))}

          {/* LESSON STEP */}
          {step === "lesson" && (
            <>
              {/* COURSE INFO */}
              {selectedCourseData && (
                <div className="p-2 sm:p-4">
                  <div className="flex flex-col md:flex-row gap-4 items-start">
                    <img
                      src={selectedCourseData.image}
                      alt="course"
                      className="w-full md:w-64 h-48 md:h-36 flex-shrink-0 object-cover rounded-lg"
                    />

                    <div className="min-w-0 w-full">
                      <h3 className="text-sm sm:text-base font-semibold my-0 break-words">
                        {selectedCourseData.name}
                      </h3>

                      {selectedCourseData.description && (
                        <p className="text-xs sm:text-sm text-gray-600 mt-1 break-words">
                          {selectedCourseData.description}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {loadingLessons ? (
                <div className="text-center py-10">
                  <img
                    src={copyLessons_loader_gif}
                    alt="Loading lessons"
                    className="w-16 mx-auto mb-2"
                  />

                  <p className="text-[15px] sm:text-[16px] font-semibold text-[#2B2B2B] text-center mt-4 px-2">
                    Fetching lessons for this course.
                    <span className="font-normal">
                      {" "}
                      This may take a moment...
                    </span>
                  </p>
                </div>
              ) : lessons.length === 0 ? (
                <div className="text-center py-10 text-gray-400">
                  <img
                    src={nodata}
                    alt="no lessons"
                    className="w-16 mx-auto mb-2"
                  />

                  <p className="text-sm sm:text-base">
                    Lessons for this course have not been created yet.
                  </p>
                </div>
              ) : (
                <>
                  {/* SELECT ALL */}
                  <div className="flex items-center gap-2 mb-4 flex-wrap">
                    <input
                      type="checkbox"
                      checked={allSelected}
                      onChange={toggleSelectAll}
                    />

                    <span
                      onClick={toggleSelectAll}
                      className="text-sm font-semibold cursor-pointer"
                    >
                      Select All{" "}
                      {Object.keys(selectedLessons).length > 0 &&
                        `(${Object.keys(selectedLessons).length} selected)`}
                    </span>
                  </div>

                  {/* LESSONS */}
                  <div className="space-y-3">
                    {lessons?.map((lesson) => {
                      const lessonId = lesson.lesson_id;

                      const isExpanded = expandedLessonId === lessonId;

                      const assignments = assignmentsMap[lessonId] || [];

                      return (
                        <div
                          key={lessonId}
                          className="border rounded-xl overflow-hidden bg-white"
                        >
                          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-4 py-3 bg-gray-50">
                            <div className="flex gap-3 items-center min-w-0">
                              <input
                                type="checkbox"
                                checked={!!selectedLessons[lessonId]}
                                onChange={() => toggleLesson(lesson)}
                              />

                              <span
                                onClick={() => toggleLesson(lesson)}
                                className="font-semibold truncate text-sm cursor-pointer"
                              >
                                {lesson.name}
                              </span>
                            </div>

                            <div className="flex items-center gap-3 min-w-[150px] justify-end">
                              <img
                                src={copy_lesson_image}
                                alt="Copy Lesson"
                                className="w-5 h-5"
                              />

                              <span className="text-blue-600 text-sm whitespace-nowrap min-w-[110px]">
                                {lesson.assignment_count || 0} Assignment
                                {lesson.assignment_count < 2 ? "" : "s"}
                              </span>

                              <button
                                onClick={() =>
                                  handleToggleLessonExpand(lessonId)
                                }
                                className="bg-transparent border-none"
                              >
                                {isExpanded ? "▲" : "▼"}
                              </button>
                            </div>
                          </div>

                          {isExpanded && (
                            <div className="px-3 sm:px-4 py-3 border-t space-y-2">
                              <div>
                                <div className="grid grid-cols-[1fr_auto] min-w-[110px] gap-4 text-xs font-semibold text-gray-500 border-b pb-2">
                                  <div>
                                    Assignment
                                    {lesson.assignment_count < 2 ? "" : "s"}
                                  </div>

                                  <div className="text-right">
                                    Assignment Type
                                  </div>
                                </div>

                                {loadingAssignments[lessonId] ? (
                                  <p>Loading...</p>
                                ) : assignments.length > 0 ? (
                                  assignments.map((assignment) => (
                                    <div
                                      key={assignment.assignment_id}
                                      className="grid grid-cols-[1fr_150px] items-center gap-2 py-2"
                                    >
                                      <div className="flex items-center gap-3 min-w-0">
                                        <input
                                          type="checkbox"
                                          checked={
                                            !!selectedAssignments[
                                              assignment.assignment_id
                                            ]
                                          }
                                          onChange={() =>
                                            toggleAssignment(lesson, assignment)
                                          }
                                        />

                                        <span
                                          onClick={() =>
                                            toggleAssignment(lesson, assignment)
                                          }
                                          className=" text-xs break-words cursor-pointer"
                                        >
                                          {assignment.name}
                                        </span>
                                      </div>

                                      <div className="text-xs text-gray-500 text-right break-words">
                                        {assignment.assignment_type ||
                                          assignment.type ||
                                          "Assignment"}
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <p>No assignment</p>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            {lessonTotalPages > 1 && (
              <div className="flex justify-center mt-5">
                <Pagination
                  count={lessonTotalPages}
                  page={lessonPage}
                  onChange={handleLessonPageChange}
                  color="primary"
                />
              </div>)}
            </>
          )}
        </div>

        {/* FOOTER */}
        {!(step === "count" && mode === "duplicate") && (
          <div className="flex flex-col sm:flex-row justify-end gap-3 px-4 sm:px-6 py-4 border-t">
            <button
              onClick={onClose}
              className="w-full sm:w-auto px-4 py-2 border rounded-md"
            >
              Cancel
            </button>

            {step !== "lesson" ? (
              selectedCourse && (
                <button
                  disabled={mode === "copy" && !selectedCourse}
                  onClick={() => setStep("lesson")}
                  className="w-full sm:w-auto px-3 py-2 bg-blue-600 border-none rounded-md text-white disabled:opacity-50"
                >
                  Select Course
                </button>
              )
            ) : (
              <button
                onClick={handleModal}
                className="w-full sm:w-auto px-3 py-2 bg-blue-600 border-none rounded-md text-white"
              >
                {mode === "copy" ? "Select Lesson" : "Duplicate Course"}
              </button>
            )}
          </div>
        )}
      </div>

      {/* CONFIRM MODAL */}
      {openDialog && (
        <div
          className="Course-created-successfully-main px-3"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="Course-created-successfully-container flex-col w-full max-w-[500px]"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={alert_img} alt="alert" />
            </div>

            <div className="Course-created-successfully-folder">
              <p className="text-base sm:text-lg my-4 text-center break-words">
                {mode === "copy"
                  ? `Are you sure you want to copy the selected Lesson${
                      lessonCount > 1 ? "s" : "" } from ${selectedCourseData?.name} to ${course?.name}?`
                  : getDuplicateMessage()}
              </p>

              <div className="Course-close-btn flex flex-col sm:flex-row gap-3 justify-center">
                <button
                  type="submit"
                  onClick={() => setOpenDialog(false)}
                  className="w-full sm:w-auto"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="Course-close w-full sm:w-auto"
                >
                  {mode === "copy" ? "Copy Lessons" : "Duplicate Course"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}